import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { CarouselItem } from "../CarouselItem";

const RequestQuoteSlide = ({ item }: { item: CarouselItem }) => (
  <div className="grid grid-cols-1">
    <div className="flex flex-row">
      <div className="product-image">
        <a href={item.link}>
          <NoScriptLazyImage alt={item.description} src={item.imagePath} />
        </a>
      </div>
      <div>
        <a href={item.link} className="description companionItemClicked">
          {item.description}
        </a>
        <div className="pricing" data-component="Pricing">
          <p className="price text-gray-800 text-xs font-bold">
            Contact for details
          </p>
        </div>
      </div>
    </div>
    <div style={{ marginTop: "5px" }} className="add-to-cart">
      <div style={{ paddingLeft: "2px" }}>
        <button
          type="button"
          role="link"
          className="btn btn-cart btn-small content-center w-28"
          onClick={() => {
            window.location.href = "/special-orders/";
          }}
        >
          <span>Request a Quote</span>
        </button>
      </div>
    </div>
  </div>
);

export default RequestQuoteSlide;
